import { apolloProvider } from "../../vue-apollo";
import { getGrupos } from "@/helpers";
import { findSistemaPerfiles } from "../../api/gruposPerfiles";
const apolloClient = apolloProvider.defaultClient;

const state = () => ({
  perfiles: [],
  grupos: [],
  loadingSave: false,
  loading: false,
});

// getters
const getters = {};

const actions = {
  findSistemaPerfiles({ commit }) {
    commit("setLoading", true);
    apolloClient
      .query({ query: findSistemaPerfiles })
      .then(({ data }) => {
        commit("setGrupos", getGrupos(data.findSistemaPerfiles));
        commit("setPerfiles", data.findSistemaPerfiles);
      })
      .catch((error) => {
        console.error(error);
        commit("setLoading", false);
      });
  },
};

// mutations
const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setLoadingSave(state, loading) {
    state.loadingSave = loading;
  },
  setPerfiles(state, perfiles) {
    state.loading = false;
    state.perfiles = perfiles;
  },
  setGrupos(state, grupos) {
    state.loading = false;
    state.grupos = grupos;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
